import styled from 'styled-components';

import { RaisedButton } from '../../assets/styles/BaseStyle';

export const ThankYouButton = styled(RaisedButton)`
  font-family: efl_iconfont;
  width: 110px;
  height: 110px;
  border-radius: 55px;
  font-size: 44px;
  padding: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.button.action.color};
  border: 0;
  
  :after {
    content: '\\54';
  }
`;

export const ThankYou = styled.div`
  margin: 20px 0;
  font-size: 32px;
`;
export const ThankYouDesc = styled.div`
  margin: 10px 0;
  font-size: 16px;
`;

export const ThankYouContainer = styled.div`
  text-align: center;
  font-size: 18px;
  margin: 20px 0;
  img {
    width: 100%;
  }
  @media (max-width:575px) and (min-width:320px){
    margin: 10% 0%;
    img {
      width: 100%;
    }
  } 
`;